import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { 
  searchProspect, 
  registerProspectAction,
  setStepAction,
  setSubStepAction,
  setProspectExistsAction,
  backToSearchAction,
  setProspectAction,
  sendConsentDataAction,
  requestNewCodeAction,
  sendConsentCodeAction,
  setMissingConsentAction,
  getConsentPreviewAction,
  setServerErrorAction,
  setClusterAction
} from 'store/slices/selfEnrollment/selfEnrollmentThunks';

const useSelfEnrollment = (initState) => {
  const [state] = useState(initState);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { prospect, cluster, loading, error, step, subStep, prospectExists, missingConsent, codeError, consentPreview, serverError } = useSelector(state => state.selfEnrollment);

  useEffect(() => {
    if( location.pathname !== '/auto-registro' || location.pathname === '' ) {
      navigate('/error');
      return;
    }
    const params = new URLSearchParams(location.search);
    const mode = params.get('mode');
    const target = capitalizeFirstLetter(params.get('target'));

    if (mode !== 'cluster' || target !== 'Araucana') {
      navigate('/error');
      return    
    }
    
    dispatch(setClusterAction(target));
  }, [location, navigate, dispatch]);

  const handleSearch = (dni) => {
    dispatch(searchProspect(dni));
  };

  const handleBeginRegister = () => {
    dispatch(setStepAction('prospect-register'));
    dispatch(setSubStepAction('prospect-search'));
  };

  const handleProspectExists = (exists) => {
    dispatch(setProspectExistsAction(exists));
  }

  const handleMissingConsent = () => {
    dispatch(setStepAction('consent'));
    dispatch(setSubStepAction('consent-data-input'));
  }

  const handleCloseSearchAlert = () => {
    dispatch(setProspectAction(null));
    dispatch(setProspectExistsAction(false));
    dispatch(setMissingConsentAction(false));
  }

  const handleSubmitForm = (prospect) => {
    const newProspect = { ...prospect };
    newProspect.lastName = `${newProspect.lastName} ${newProspect.secondLastName}`;
    newProspect.birthDay = `${newProspect.day}-${newProspect.month}-${newProspect.year}`;
    newProspect.phone = `${newProspect.pre} ${newProspect.phone}`;
    newProspect.holdingName = cluster
    delete newProspect.day;
    delete newProspect.month;
    delete newProspect.year;
    delete newProspect.secondLastName;
    delete newProspect.pre;
    dispatch(registerProspectAction(newProspect));
  }

  const handleBackToSearch = () => {
    dispatch(backToSearchAction());
  }

  const handleToConsent = () => {
    dispatch(setStepAction('consent'));
    dispatch(setSubStepAction('consent-data-input'));
  }

  const handleToInputCode = () => {
    dispatch(sendConsentDataAction(prospect));
  }

  const handleValidateCode = (code) => {
    dispatch(sendConsentCodeAction(prospect, code));
  }

  const handleRequestNewCode = () => {
    dispatch(requestNewCodeAction(prospect));
  }

  const handlePhoneChange = (phone) => {
    phone = phone.length === 9 ? `56 ${phone}` : phone;
    const updateProspect = { ...prospect, phone: phone };
    dispatch(setProspectAction(updateProspect));
  }

  const handleEmailChange = (email) => {
    const updateProspect = { ...prospect, email: email };
    dispatch(setProspectAction(updateProspect));
  }

  const handleConsentPreview = () => {
    dispatch(getConsentPreviewAction(prospect));
  }

  const handleCleanServerError = () => {
    dispatch(setServerErrorAction(null));
  }

  const capitalizeFirstLetter = (string) => {
      return string.charAt(0).toUpperCase() + string.slice(1);
  }

  return {
    state,
    prospect,
    loading,
    step,
    subStep,
    prospectExists,
    missingConsent,
    error,
    codeError,
    serverError,
    consentPreview,
    handleSearch,
    handleBeginRegister,
    handleProspectExists,
    handleSubmitForm,
    handleBackToSearch,
    handleToConsent,
    handleToInputCode,
    handleValidateCode,
    handlePhoneChange,
    handleEmailChange,
    handleRequestNewCode,
    handleCloseSearchAlert,
    handleMissingConsent,
    handleConsentPreview,
    handleCleanServerError
  };
}

export default useSelfEnrollment;